<div class="container fullheight">
    <mat-card>
        <div class="row flex-column justify-content-center">
            <div class="col d-flex justify-content-center">
                <img class="error-img" src="{{ selectedImage }}" />
            </div>
            <div class="col d-flex justify-content-center flex-column mb-4">
                <mat-card-title>
                    <p class="text-center fs-1">Oops!</p>
                </mat-card-title>
                <p class="text-center fs-2">Something went wrong.</p>
                <p p class="text-center fs-4">
                    An error has occurred but we are working on it.<br />
                    If you need help sooner please contact us at
                    <span class="accent-color fw-bold"><a
                            href="mailto:concierge@safely.com">concierge&#64;safely.com</a></span>
                </p>
                <p p class="text-center fs-4">Thank you for your patience.</p>
            </div>
        </div>
    </mat-card>
</div>